import { Modal, notification } from "ant-design-vue";
import { toRaw } from "vue";
import i18n from "../../i18n";
import { randomUuid } from "../../utils/util";
import { initRowSelection } from "./c-table.logic";

export const onClickManage = ({ props, manage }) => {
    if (manage.rowSelection) {
        props.dataTable.manageSelect = manage;
        initRowSelection({ props: props.propsTable, data: props.dataTable, refs: props.refsTable });
    } else {
        manage.onClick?.({ columns: props.propsTable.columns, page: props.dataTable.page });
    }
};

export const onClickManageCancel = ({ props }) => {
    const manageSelectForce = props.manages?.find(manage => manage.visible?.() && manage.force);
    props.dataTable.manageSelect = manageSelectForce;
    props.dataTable.rowSelection = null;
    if (manageSelectForce) {
        initRowSelection({ props: props.propsTable, data: props.dataTable, refs: props.refsTable });
    }
    props.dataTable.tableKey = randomUuid();
};

export const onClickManageOk = ({ props }) => {
    const { selectedRowKeys, selectedRows } = toRaw(props.dataTable.rowSelection);
    const rowSelection = { selectedRowKeys, selectedRows };
    if (selectedRowKeys.length === 0) {
        notification["error"]({ message: i18n.global.t("components.table.operatorAndPagination.noSelect") });
        return;
    }
    if (props.dataTable.manageSelect.confirm) {
        Modal.confirm({
            title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: props.dataTable.manageSelect.text() }),
            autoFocusButton: "cancel",
            onOk: () => handlerManageOk({ props, rowSelection }),
            ...props.dataTable.manageSelect.confirm({ rowSelection })
        });
    } else {
        handlerManageOk({ props, rowSelection });
    }
};

const handlerManageOk = ({ props, rowSelection }) => {
    props.dataTable.manageSelect.onClick?.({ rowSelection });
    const clearOnManageOk = props.propsTable.clearOnManageOk;
    if (clearOnManageOk) {
        onClickManageCancel({ props });
    }
};

export const getManages = ({ props }) => {
    return props.manages.filter(manage => manage.visible?.() && !manage.force);
};
